import React from "react";

interface CardProps {
    children: React.ReactNode;
    className?: string;
    variant?: "default" | "dark" | "light";
    padding?: "none" | "sm" | "md" | "lg" | "xl";
    joinClassName?: string;
    innerClassName?: string;
}

export const Card: React.FC<CardProps> = ({
    children,
    className = "",
    variant = "dark",
    padding = "md",
    innerClassName = "",
}) => {
    const baseClasses = "relative";

    const variants = {
        default: "bg-white border-gray-200 text-gray-900",
        dark: "bg-bgCard border-cardBorder text-white",
        light: "bg-gray-50 border-gray-300 text-gray-900",
    };

    const paddingClasses = {
        none: "",
        sm: "p-3",
        md: "p-6",
        lg: "p-8",
        xl: "p-10",
    };

    const cornerBorderClasses = `
    after:h-1 after:w-1 after:top-0 after:left-0 after:border-t after:border-l after:border-accentPurple after:absolute 
    before:h-1 before:w-1 before:top-0 before:right-0 before:border-t before:border-r before:border-accentPurple before:absolute
  `;

    const innerCornerBorderClasses = `
    after:h-1 after:w-1 after:bottom-0 after:left-0 after:border-b after:border-l after:border-accentPurple after:absolute 
    before:h-1 before:w-1 before:bottom-0 before:right-0 before:border-b before:border-r before:border-accentPurple before:absolute
  `;

    const classes = `${baseClasses} ${cornerBorderClasses} ${className}`;
    const innerClasses = `${variants[variant]} border ${paddingClasses[padding]} ${innerCornerBorderClasses} ${innerClassName}  ]}`;

    return (
        <div className={classes}>
            <div className={innerClasses}>{children} </div>
        </div>
    );
};
